import { identify } from "utils/mixpanel"

export function mixpanelIdentifyUser(user) {
  if (!user || !user.id) return

  identify(user.id, {
    email: user.email,
    plan: user.subscription?.plan_id,
    name: user.name
  })
}
